import React from 'react';
import ReactDOM from 'react-dom';
import InfiniteScroll from '../InfiniteScroll';
import SmallPost from '../Models/SmallPost';

class CategoryPage extends React.Component {
  constructor(props) {
    super(props);

    this.state =  {
      pagetype: '',
      endpoint: `category/${window.category.id}`,
      urlStructure: '%domain%/%categorySlug%/page/%id%/'
    };
  }


  componentDidMount() {
    this.getInitialState();
  }

  getInitialState() {
    this.setState(() => ({  
      pagetype: 'category',
    }));
  }

  getSeoDataArray(post) {
    let seoDataArray = [];

    if (!post) {
      return seoDataArray;
    }
    
    const term = post.categories.find(({ id }) => id == window.category.id)
    if (!term) {
      return seoDataArray;
    }

    seoDataArray['aller_ga'] = term.seoData.aller_ga ?? {};
    
    return seoDataArray;
  }

  render() {
    return (
      <InfiniteScroll 
        pageId={this.props.pageId} 
        urlStructure={this.state.urlStructure} 
        perPage={12} 
        endpoint={this.state.endpoint} 
        pagetype={this.state.pagetype}
        getSeoDataArray={this.getSeoDataArray}
        >
        <SmallPost rowCount={3} fitAdsToContent={true}/>
      </InfiniteScroll>
    )
  } 

}
let categoryPageElement = document.getElementById('category');
if (categoryPageElement) {
  ReactDOM.render(<CategoryPage pageId={categoryPageElement.dataset.pageid}/>, categoryPageElement);
}